export enum UPLOAD_STATUS {
  LIVE = 'live',
  UPLOADING = 'uploading'
}

export const VIDEO_PROCESSING_INDICATOR = 'lia-video-processing-indicator';
export const DATA_IMAGE_CONTAINER = 'data-lia-image-container';
export const DATA_MEDIA = 'data-lia-image';
export const DATA_VIDEO_STATUS = 'data-lia-video-status';
export const DATA_MEDIA_TITLE = 'data-lia-video-title';
export const DATA_VIDEO_THUMBNAIL = 'data-lia-video-thumbnail';
export const VIDEO_PLAYER = 'lia-video-player';
export const audioFileTypes = ['m4a', 'mp3', 'wma', 'aac', 'wav'];
